export default "__VITE_ASSET__f7c40743__"